/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSideBarContext } from "#contexts/sidebarContext.jsx";
import { useLocation, useNavigate } from "react-router-dom";

const SidebarTab = ({ data }) => {
  const location = useLocation(); // Get the current location
  const { toggleSidebar } = useSideBarContext();
  const nav = useNavigate();

  function getBasePath(path) {
    const segments = path.split("/").filter(Boolean);
    return `/${segments.slice(0, 2).join("/")}`;
  }

  // Function to determine if a link is active based on its pathname
  const isLinkActive = (pathname) => {
    return getBasePath(location.pathname) === pathname;
  };
  const handleNavigation = (path) => {
    nav(path);
    window.innerWidth <= 992 && toggleSidebar();
  };

  return (
    <li className="nav-item sidebar-link">
      <a
        className={isLinkActive(data.path) ? "nav-link active" : "nav-link"}
        onClick={() => handleNavigation(data.path)}
      >
        <span className="nav-icon">
          <img src={data.Icon} alt="Dashboard" />
        </span>
        <span className="nav-text">{data.title}</span>
      </a>
    </li>
  );
};
export default SidebarTab;
